import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { SiteSettingStore } from './site-setting.store';

@Injectable({
    providedIn: 'root'
})
export class SiteSettingQuery extends BaseQuery {

    constructor(store: SiteSettingStore) {
        super(store);
    }


}
